import _every from "lodash/every";

export type RoleTestFn = (role: string) => boolean;

/**
 * Whether the user can view dj messages
 * @param role
 */
export const canViewMessages: RoleTestFn = (role) => {
  return role === "dj";
};

export const canViewAdminPage: RoleTestFn = (role) => {
  return role !== "guest";
};

/**
 * Whether the user can edit posts
 * @param role
 */
export const canEditPosts: RoleTestFn = (role) => {
  return role === "editor";
};

/**
 * Combines role test funcitons ... not currently needed
 * @param roleTestFns
 */
export const requireAll = (roleTestFns: RoleTestFn[]): RoleTestFn => {
  return (role: string): boolean => {
    return _every(
      roleTestFns.map((fn) => {
        return fn(role);
      })
    );
  };
};
